module.exports = __webpack_public_path__ + "img/control-1-760.c4293e0.jpg";